import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/WeChat/';

const state = {};

const mutations = {};

const actions = {
  GetAuthLink({commit}, view) {
    return request.PromiseCall(basePath, 'GetAuthLink', view);
  },
  GetJsApiSign({commit}, view) {
    return request.PromiseCall(basePath, 'GetJsApiSign', view);
  },
  SyncFansInfo: function ({commit}, view) {
    return request.PromiseCall(basePath, 'SyncFansInfo', view);
  },


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/WeChat/index.js